import { ButtonConfig, ConfirmComponent } from '@web/app/components/dialogs/confirm/confirm.component';
import { tr } from '@util/tr/tr';
import { inject } from '@util/inject';
import { MatDialog } from '@angular/material/dialog';

export interface ConfirmConfig {
  message: string;
  title?: string;
  /** ws-button type of the confirm button (default primary). */
  yesCallToActionType?: 'primary' | 'danger';
  buttons: {
    yes?: ButtonConfig;
    no?: ButtonConfig
  }
}

const open = async (cfg: ConfirmConfig): Promise<boolean> => {
  const dlg: MatDialog = await inject(MatDialog);
  const ref = dlg.open(ConfirmComponent, {
    data: cfg
  });
  return (await ref.afterClosed().toPromise()) || false;
}

const yesno = async (message: string, yesText: string = 'Yes', noText: string = 'No'): Promise<boolean> => {
  if (yesText === 'Yes') yesText = tr('Yes');
  if (noText === 'No') noText = tr('No');
  return open({
    message,
    buttons: {
      yes: {
        display: true,
        text: yesText
      },
      no: {
        display: true,
        text: noText
      }
    }
  })
}

const yes = async (message: string, yesText: string = 'Yes'): Promise<boolean> => {
  if (yesText === 'Yes') yesText = tr('Yes');
  return open({
    message,
    buttons: {
      yes: {
        display: true,
        text: yesText
      },
      no: {
        display: false,
        text: ''
      }
    }
  })
}

/** Titled yes/no dialog (WS-4273): «Annulla» / action, optional danger confirm. */
const dialog = async (cfg: {
  title: string;
  message: string;
  yesText: string;
  noText?: string;
  yesCallToActionType?: 'primary' | 'danger';
}): Promise<boolean> =>
  open({
    title: cfg.title,
    message: cfg.message,
    yesCallToActionType: cfg.yesCallToActionType,
    buttons: {
      yes: { display: true, text: cfg.yesText },
      no: { display: true, text: cfg.noText || tr('Cancel') },
    },
  });

const confirm = { yesno, yes, dialog };

export { confirm }


